export const INVOICE_PDF_I18N_ENTRIES = {
  invoice_pdf_Data1: {
    es: '<p>E-CAPTURE RESEARCH AND DEVELOPMENT SL</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data2: {
    es: '<p>Paseo Fluvial, Nº 15, Planta 11</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data3: {
    es: '<p>Badajoz 06011</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data4: {
    es: '<p>customercare@eyesnroad.com</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data5: {
    es: '<p>BXXXXXXXX</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data6: {
    es: '<p>NÚMERO</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data7: {
    es: '<p>PÁGINA</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data8: {
    es: '<p>FECHA</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data9: {
    es: '<p>Factura</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data10: {
    es: '<p>Forma de pago:</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data11: {
    es: '<p>Fecha de vencimiento:</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data12: {
    es: '<p>DESCRIPCIÓN</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data13: {
    es: '<p>CANTIDAD</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data14: {
    es: '<p>PRECIO UNIDAD</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data15: {
    es: '<p>SUBTOTAL</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data16: {
    es: '<p>DTO.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data17: {
    es: '<p>TOTAL</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data18: {
    es: '<p>BASE</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data19: {
    es: '<p>TIPO</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data20: {
    es: '<p>I.V.A</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data21: {
    es: '<p>Rogamos abonen la mencionada cantidad mediante ingreso bancario a la c. c. ESXX XXXX XXXX XXXX XXXX XXXX de eyesNroad</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data22: {
    es: '<p>S.L. indicando como referencia el número de factura.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data23: {
    es: '<p>De conformidad con lo establecido en la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data24: {
    es: '<p>digitales así como el Reglamento (UE) 2016/679 relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data25: {
    es: '<p>personales, en ECAPTURE RESEARCH AND DEVELOPMENT SL tratamos los datos que nos proporciona con el fin de prestarle nuestros servicios.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data26: {
    es: '<p>Los datos permanecerán en nuestros ficheros durante el tiempo que dure la relación comercial. Asimismo, podrán ser cedidos a terceros para</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data27: {
    es: '<p>cumplir con obligaciones legales o en los casos que se indican en la Política de Privacidad. Le informamos de la posibilidad que tiene de ejercer</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data28: {
    es: '<p>los derechos de acceso, rectificación, cancelación y oposición de sus datos de carácter personal mediante escrito dirigido a: Paseo Fluvial, Nº</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data29: {
    es: '<p>15, Planta 11, acompañando copia de DNI.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
  invoice_pdf_Data30: {
    es: '<p>Factura_%X%</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
  },
};
